// extracted by mini-css-extract-plugin
module.exports = {"container":"PassedFileTerm_container__FRbo_"};